export default __webpack_public_path__ + "static/03_process-4bb866e7f7bf2d02e796e6877c1eda81.mp4";